module.exports = __webpack_public_path__ + "./fonts/DMSans-MediumItalic.248753.woff";